export default {"src":"/_next/static/media/logo_black.85d57472.svg","height":233,"width":787,"blurWidth":0,"blurHeight":0};